import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTenant } from '../context/TenantContext';
import { useUser } from '../context/UserContext';
import { useMembership } from '../context/MembershipContext';
import { MODULE_IDS } from './constants';
import { getDefaultModulePath } from './moduleNavigation';
import { canManageTenantForTenant } from './membershipPermissions';

/** Redirects to default module when tenant config disables the target module. */
export function ModuleRouteGuard({ moduleId, children }) {
  const { isModuleEnabled, config, tenantId } = useTenant();
  const { user } = useUser();
  const { memberships } = useMembership();

  if (!isModuleEnabled(moduleId)) {
    return <Navigate to={`/${getDefaultModulePath(config)}`} replace />;
  }

  if (
    moduleId === MODULE_IDS.USER_MANAGEMENT
    && !canManageTenantForTenant(memberships, tenantId, user)
  ) {
    return <Navigate to={`/${getDefaultModulePath(config)}`} replace />;
  }

  return children;
}
